<template>
  <v-card v-on="getEvent" class="dr-content-item-card dr-content-item-card-image" :style="backgroundImg">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">{{evaluateExpression(model.Title)}}</v-list-item-title>
        <v-list-item-subtitle>{{evaluateExpression(model.SubTitle)}}</v-list-item-subtitle>
        <dr-simple-layout v-bind="$props" @callDataSourceAction="$emit('callDataSourceAction', $event)"></dr-simple-layout>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import actionMixin from '../../mixins/actions-mixin'

export default {
  name: 'dr-content-item-component',
  mixins: [mixin, inputMixin, actionMixin],
  props: ['model', 'dataSource'],
  computed: {
    backgroundImg() {
      let image = this.getDataSourceField(this.model.BackgroundImg)
      if (!image) {
        return ''
      }
      return `background-image: url(${image})`
    },
    getEvent() {
      if (this.model.OnClickAction?.Type) { 
        return { click: this.actionOnClick }
      }
      return {}
    }
  },
  methods: {
    actionOnClick() {
      this.invokeActionOnClick(this.model.OnClickAction)
    }
  }
}
</script>

<style>
.dr-content-item-card {
  margin-bottom: 15px;
}
.dr-content-item-card-image {
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
</style>
